export const SUIVI_FACTURES = {
    CLEAR_ALL: 'SUIVI_FACTURES_CLEAR_ALL',
};
